import { Injectable, TemplateRef } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  toasts: any[] = [];

  constructor() {}

  show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    this.toasts.push({ textOrTpl, ...options });
  }

  remove(toast: any) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }

  class(toast: any){
    let claseToast = 'bg-default text-ligth';
    switch (toast.type) {
      case 'error':
        claseToast = 'bg-danger text-light';
        break;

      case 'success':
        claseToast = 'bg-success text-light';
        break;

      case 'warning':
        claseToast = 'bg-warning text-light';
        break;
    }
    return claseToast;
  }
  
}
